export default __webpack_public_path__ + "static/media/download-white.23fbab84.svg";